module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-17.c53c7f4d.png";